import { Button } from 'aimo-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useUiStore } from 'stores/uiStore';

const CancelTermination = ({
  textKey,
  testID,
  terminateBoth,
}: {
  textKey: string;
  testID?: string;
  terminateBoth: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <Button
      size="l"
      testID={testID}
      buttonType={terminateBoth ? 'transparent' : 'tertiary'}
      text={t(textKey)}
      onPress={() => useUiStore.getState().setSheetModal('')}
    />
  );
};

export default CancelTermination;
